export default "__VITE_ASSET__CzNHn3bc__"